// extracted by mini-css-extract-plugin
export default {"root":"onlineIndicator__root__AdRA7","text":"onlineIndicator__text__luc5J","icon":"onlineIndicator__icon__brnxN","offline":"onlineIndicator__offline__iEm9v"};